import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { lookupsService } from "../services/LookupsService";
import PoliticalPartyService from "../services/PoliticalPartyService";

export default function AddPartyDocument({ PoliticalPartyID = "", buttonIcon = "pi pi-save", show = false, setShow, onSubmit }) {
	const toast = useRef(null);
	const inputFileRef = useRef(null);

	var [form, setForm] = useState({
		FileData: "",
		FileName: "",
		FileExtension: "",
		DocumentTypeID: ""
	});

	var [documentTypes, setDocumentTypes] = useState([]);
	var [selectedDocumentType, setSelectedDocumentType] = useState(null);
	var user = JSON.parse(localStorage.getItem("central-site-user"));
	var submittedForm = false;

	var [loading, setLoading] = useState(true);

	useEffect(() => {
		setForm({ ...form, FileData: "", FileName: "", FileExtension: "", DocumentTypeID: "", ContentType: "" });
	}, []);

	function documentTypeHandler(val) {
		form.DocumentTypeID = val;
		setSelectedDocumentType(val);
	}

	function getDocumentTypes() {
		// documentTypeService.getDocumentTypes().then((data) => {
		//     setDocumentTypes(data);
		// });
	}

	const isValid = () => {
		return form.DocumentTypeID !== "" && form.FileName !== "";
	};

	var convertBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);
			fileReader.onload = () => {
				resolve(fileReader.result);
			};
			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const onSelectFileClick = () => {
		inputFileRef.current.click();
	};

	async function onUploadHandler(e) {
		const file = e.files[0];
		const base64 = await convertBase64(file);
		var base64result = base64.split(",")[1];

		const extension = file.name.split(".").pop();

		setForm({ ...form, FileData: base64result, FileName: file.name, FileExtension: extension, ContentType: file.type });
	}

	function SubmitForm() {
		setLoading(true);
		var model = {
			PoliticalPartyID: "",
			Title: form.FileName,
			FileExtension: form.FileExtension,
			ContentType: form.ContentType,
			BinaryData: form.FileData,
			DocumentTypeID: form.DocumentTypeID,
			Description: "",
			Created_By: user?.id ? user.id : 1,
			PoliticalPartyID: PoliticalPartyID
		};

		var politicalPartySvc = new PoliticalPartyService();

		politicalPartySvc
			.createDocument(model)
			.then((res) => {
				setLoading(false);
				setForm({ ...form, FileData: "", FileName: "", FileExtension: "", ContentType: "" });
				setShow(false);
				onSubmit();
				return toast.current.show({
					severity: "success",
					summary: "Success Message",
					detail: "Document created successfully",
					life: 1500
				});
			})
			.catch((e) => {
				submittedForm = false;
				setLoading(false);
				return toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 2000
				});
			});
	}

	return (
		<Dialog
			draggable={false}
			header={
				<>
					<li className="pi pi-plus"> </li>
					<span>Add Document</span>
				</>
			}
			footer={
				<>
					<Button
						onClick={SubmitForm}
						className="p-button-success"
						type="button"
						label={loading ? "Processing..." : "Submit"}
						icon={loading ? "pi pi-spin pi-spinner" : ""}
						disabled={!isValid() || loading}
					/>
				</>
			}
			visible={show}
			onHide={(e) => setShow(false)}
			onShow={() => {
				getDocumentTypes();
				setForm({ ...form, FileData: "", FileName: "", FileExtension: "", DocumentTypeID: "" });
			}}
		>
			<div className="grid">
				<div className="col-12 lg:col-12">
					<Toast ref={toast} />
					<form>
						<TabView>
							<TabPanel header="Document Details">
								<div className="grid">
									<div className="col-12">
										<label>
											Document Type <span style={{ color: "red" }}>*</span>
										</label>
										<div style={{ visibility: "hidden" }}>File</div>
										<Dropdown
											optionLabel="Name"
											optionValue="DocumentTypeID"
											onChange={(e) => documentTypeHandler(e.value)}
											options={documentTypes}
											value={selectedDocumentType}
											placeholder="-Select-"
											style={{ width: "100%" }}
										/>
									</div>
									<div className="col-12">
										<label htmlFor="description">
											File <span style={{ color: "red" }}>*</span>
										</label>
										<div style={{ visibility: "hidden" }}>File</div>
										<React.Fragment>
											<Button
												label="Select a file"
												onClick={onSelectFileClick}
												className="p-button-success"
												icon="pi pi-plus"
												type="button"
											/>
											<input
												ref={inputFileRef}
												type={"file"}
												onChange={(e) => onUploadHandler(e.target)}
												style={{ display: "none" }}
												accept="application/pdf"
											></input>
										</React.Fragment>
										<div style={{ visibility: "hidden" }}>File</div>
										{form.FileName.trim().length === 0 ? (
											""
										) : (
											<span width="100px" style={{ width: "100px", objectFit: "cover" }}>
												<i className={PrimeIcons.FILE_PDF} style={{ fontSize: "16px", color: "red" }}></i> {form.FileName}
											</span>
										)}
									</div>
								</div>

								<div className="grid"></div>
							</TabPanel>
						</TabView>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
